import { DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu";
import { Table } from "@tanstack/react-table";
import { Filter, Settings2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { ModalFilters } from "./modal-filters";
import { useGetFilteredStoresQuery } from "@/services/store/store";
import { Load } from "components/load";

interface DataTableViewOptionsProps<TData> {
  table: Table<TData>;
}

export function DataTableViewOptions<TData>({
  table,
}: DataTableViewOptionsProps<TData>) {
  const { isLoading } = useGetFilteredStoresQuery({
    perPage: 300,
    page: 1,
  });

  const { handleModal } = useDialogModal();
  const handleOpenModal = () => {
    if (isLoading) {
      return <Load />;
    }
    handleModal({
      isOpen: true,
      element: <ModalFilters />,
      title: "Filtro",
    });
  };

  const columnNames = {
    store: "Loja",
    release_sequence: "Sequência",
    operation_type: "Tipo de Operação",
    operation_number: "Número",
    value: "Valor",
    operation_date: "Data",
    user: "Usuário",
    observation: "Observação",
    nsu_tef: "NSU",
  };

  return (
    <div className="flex gap-4">
      <Button
        variant="outline"
        size="sm"
        className="ml-auto hidden h-8 lg:flex"
        onClick={handleOpenModal}
      >
        <Filter />
        Aplicar Filtro
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="ml-auto hidden h-8 lg:flex"
          >
            <Settings2 />
            Visualizar
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[150px]">
          <DropdownMenuLabel>Colunas</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {table
            .getAllColumns()
            .filter(
              (column) =>
                typeof column.accessorFn !== "undefined" && column.getCanHide()
            )
            .map((column) => {
              return (
                <DropdownMenuCheckboxItem
                  key={column.id}
                  className="capitalize"
                  checked={column.getIsVisible()}
                  onCheckedChange={(value) => column.toggleVisibility(!!value)}
                >
                  {columnNames[column.id as keyof typeof columnNames] ?? "item"}
                </DropdownMenuCheckboxItem>
              );
            })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
